var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(23 93)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-23 -93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 92.925)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.667,7.575l7.342,1.458A1.231,1.231,0,0,1,20,10.25v8.5A1.248,1.248,0,0,1,18.75,20h-7.5a.413.413,0,0,0,.417-.417v-.417H18.75a.418.418,0,0,0,.417-.417v-8.5a.419.419,0,0,0-.325-.408L11.667,8.425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.25,11.667a.417.417,0,0,1,0,.833H14.583a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.25,14.167a.417.417,0,0,1,0,.833H14.583a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.25,16.667a.417.417,0,0,1,0,.833H14.583a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.667,19.583a.417.417,0,0,1-.833,0V7.917a.443.443,0,0,1,.15-.325.438.438,0,0,1,.35-.083l.333.067V19.583Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.833,19.167v.417A.413.413,0,0,0,11.25,20H7.917a.413.413,0,0,0,.417-.417v-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.75,4.167A.417.417,0,1,1,8.75,5H7.083a.417.417,0,0,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.167,7.083A.413.413,0,0,1,8.75,7.5H7.083a.417.417,0,0,1,0-.833H8.75A.413.413,0,0,1,9.167,7.083Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.75,9.167a.417.417,0,1,1,0,.833H7.083a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.75,11.667a.417.417,0,1,1,0,.833H7.083a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,12.083a.413.413,0,0,1-.417.417H2.917a.417.417,0,1,1,0-.833H4.583A.413.413,0,0,1,5,12.083Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.583,4.167a.417.417,0,0,1,0,.833H2.917a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.583,6.667a.417.417,0,0,1,0,.833H2.917a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.583,9.167a.417.417,0,1,1,0,.833H2.917a.417.417,0,1,1,0-.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,15.417A.418.418,0,0,0,7.083,15h-2.5a.413.413,0,0,0-.417.417v3.75H3.333v-3.75a1.248,1.248,0,0,1,1.25-1.25h2.5a1.248,1.248,0,0,1,1.25,1.25v3.75H7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.167,19.167H8.333v.417A.413.413,0,0,1,7.917,20H3.75a.413.413,0,0,1-.417-.417v-.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.458.167l9.158,1.392a1.245,1.245,0,0,1,1.05,1.233V7.575l-.333-.067a.438.438,0,0,0-.35.083.443.443,0,0,0-.15.325V2.792a.421.421,0,0,0-.35-.417L1.325.992A.231.231,0,0,0,1.25.983a.393.393,0,0,0-.267.1.4.4,0,0,0-.15.317V18.75a.418.418,0,0,0,.417.417H3.333v.417A.413.413,0,0,0,3.75,20H1.25A1.248,1.248,0,0,1,0,18.75V1.4A1.227,1.227,0,0,1,.442.45,1.251,1.251,0,0,1,1.458.167Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.f4e5844f.svg";
export { ForwardRef as ReactComponent };